var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "svincolati" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showTitle,
                expression: "showTitle",
              },
            ],
            staticClass: "titolo navy--text text--lighten-2 font-hemi-head",
          },
          [_vm._v("\n      Svincolati\n    ")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "svincolati-options" },
          [
            _vm.showButtonScartati
              ? _c(
                  "v-row",
                  {
                    attrs: {
                      align: "center",
                      justify: "center",
                      "no-gutters": "",
                    },
                  },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c(
                          "v-btn",
                          {
                            staticClass: "px-4 font-weight-bold white--text",
                            attrs: { small: "", color: "primary" },
                            on: { click: _vm.manageScartati },
                          },
                          [
                            _c(
                              "span",
                              {
                                staticClass: "scartati-person-icon mr-2",
                                attrs: { "aria-hidden": "true" },
                              },
                              [
                                _c(
                                  "v-icon",
                                  { attrs: { small: "", color: "white" } },
                                  [_vm._v("person")]
                                ),
                              ],
                              1
                            ),
                            _vm._v("\n              Scartati\n              "),
                            _c(
                              "v-icon",
                              {
                                attrs: { small: "", right: "", color: "white" },
                              },
                              [_vm._v("chevron_right")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.classicMode
              ? _c(
                  "div",
                  { staticClass: "d-flex align-center justify-center" },
                  [
                    _c("select-ruoli-classic", {
                      attrs: { ruoliAllowed: _vm.ruoliAllowed },
                      model: {
                        value: _vm.selectedRuoloClassic,
                        callback: function ($$v) {
                          _vm.selectedRuoloClassic = $$v
                        },
                        expression: "selectedRuoloClassic",
                      },
                    }),
                    _vm._v(" "),
                    _vm.showInformazioni
                      ? _c(
                          "v-icon",
                          {
                            attrs: { color: "text", small: "" },
                            on: { click: _vm.showDialogInformazioni },
                          },
                          [_vm._v("info")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _c(
                  "v-row",
                  {
                    attrs: {
                      align: "center",
                      justify: "center",
                      "no-gutters": "",
                    },
                  },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "auto" } },
                      [
                        _c("select-ruoli-mantra", {
                          model: {
                            value: _vm.selectedRuoliMantra,
                            callback: function ($$v) {
                              _vm.selectedRuoliMantra = $$v
                            },
                            expression: "selectedRuoliMantra",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
            _vm._v(" "),
            _vm.showStatsAndSearch
              ? _c(
                  "v-row",
                  {
                    attrs: {
                      align: "center",
                      justify: "space-between",
                      dense: "",
                    },
                  },
                  [
                    _vm.showStats
                      ? _c(
                          "v-col",
                          {
                            staticClass:
                              "svincolati-actions d-flex align-center",
                            attrs: { cols: "auto" },
                          },
                          [
                            _vm.anniStats.length > 0
                              ? _c(
                                  "v-btn",
                                  {
                                    staticClass:
                                      "navy darken-3 navy--text text--lighten-3 py-4",
                                    attrs: {
                                      "x-small": "",
                                      rounded: "",
                                      depressed: "",
                                    },
                                    on: { click: _vm.rotateAnniStats },
                                  },
                                  [
                                    _c(
                                      "transition",
                                      {
                                        attrs: { name: "roll", mode: "out-in" },
                                      },
                                      [
                                        _c("b", { key: _vm.annoStats }, [
                                          _vm._v(_vm._s(_vm.annoStats)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass:
                                  "btnHomeAway navy darken-3 navy--text text--lighten-3 py-4",
                                attrs: {
                                  "x-small": "",
                                  rounded: "",
                                  depressed: "",
                                },
                                on: { click: _vm.rotateHomeAway },
                              },
                              [
                                _c(
                                  "transition",
                                  { attrs: { name: "roll", mode: "out-in" } },
                                  [
                                    _c("div", { key: _vm.homeAway }, [
                                      _vm.homeAway == "home"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("fa-home")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.homeAway == "away"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("fa-plane")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.homeAway == "homeAway"
                                        ? _c(
                                            "div",
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("fa-home")]
                                              ),
                                              _vm._v(
                                                "\n                    +\n                    "
                                              ),
                                              _c(
                                                "v-icon",
                                                { attrs: { "x-small": "" } },
                                                [_vm._v("fa-plane")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ]),
                                  ]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-menu",
                              {
                                attrs: {
                                  "offset-y": "",
                                  "content-class":
                                    "svincolati-sort-menu-content",
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function (ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "v-btn",
                                            _vm._g(
                                              {
                                                staticClass:
                                                  "btnSort navy darken-3 navy--text text--lighten-3 px-2 py-4",
                                                attrs: {
                                                  "x-small": "",
                                                  rounded: "",
                                                  depressed: "",
                                                },
                                              },
                                              on
                                            ),
                                            [
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "mr-1",
                                                  attrs: { "x-small": "" },
                                                },
                                                [_vm._v("fa-sort")]
                                              ),
                                              _vm._v(" "),
                                              _vm.currentSortOption
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "sort-option-icon sort-option-icon--trigger",
                                                    },
                                                    [
                                                      _vm.currentSortOption
                                                        .iconType === "img"
                                                        ? _c("span", {
                                                            staticClass:
                                                              "sort-option-img",
                                                            style:
                                                              _vm.sortOptionImgStyle(
                                                                _vm.currentSortOption
                                                              ),
                                                          })
                                                        : _vm.currentSortOption
                                                            .iconType === "text"
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "sort-option-text-icon",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .currentSortOption
                                                                    .icon
                                                                )
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                "x-small": "",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .currentSortOption
                                                                    .icon
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  2065885043
                                ),
                              },
                              [
                                _vm._v(" "),
                                _c(
                                  "v-list",
                                  {
                                    staticClass:
                                      "svincolati-sort-menu navy darken-2",
                                    attrs: { dark: "", dense: "" },
                                  },
                                  _vm._l(_vm.sortOptions, function (option) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: option.value,
                                        class: {
                                          "svincolati-sort-menu__item--selected":
                                            _vm.selectedSort == option.value,
                                        },
                                        on: {
                                          click: function ($event) {
                                            _vm.selectedSort = option.value
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-icon",
                                          { staticClass: "mr-3" },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "sort-option-icon",
                                                class: {
                                                  "sort-option-icon--selected":
                                                    _vm.selectedSort ==
                                                    option.value,
                                                },
                                              },
                                              [
                                                option.iconType === "img"
                                                  ? _c("span", {
                                                      staticClass:
                                                        "sort-option-img",
                                                      style:
                                                        _vm.sortOptionImgStyle(
                                                          option
                                                        ),
                                                    })
                                                  : option.iconType === "text"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "sort-option-text-icon",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(option.icon)
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          small: "",
                                                          color:
                                                            _vm.selectedSort ==
                                                            option.value
                                                              ? "secondary"
                                                              : "navy lighten-3",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(option.icon)
                                                        ),
                                                      ]
                                                    ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(_vm._s(option.text)),
                                            ]),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-list-item-action",
                                          [
                                            _vm.selectedSort == option.value
                                              ? _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      color: "secondary",
                                                    },
                                                  },
                                                  [_vm._v("check")]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "v-col",
                      [
                        _c("v-text-field", {
                          staticClass: "calciatori-search",
                          attrs: {
                            "prepend-icon": "search",
                            label: "Nome o squadra...",
                            color: "navy lighten-2",
                            "append-icon":
                              _vm.nameFilter.length != 0 ? "cancel" : "",
                            "hide-details": "",
                          },
                          on: { "click:append": _vm.resetFilter },
                          model: {
                            value: _vm.nameFilter,
                            callback: function ($$v) {
                              _vm.nameFilter = $$v
                            },
                            expression: "nameFilter",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "svincolati-list" }, [
          _vm.id_calciatori_svincolati.length == 0
            ? _c("div", { staticClass: "text-center pa-10" }, [
                _vm._v("\n        Nessuno svincolato in questo ruolo."),
                _c("br"),
                _vm._v(" "),
                _vm.showButtonScartati && !_vm.includiScartati
                  ? _c("div", [
                      _vm._v(
                        '\n          PS: Clicca su "Scartati" per rivedere i calciatori che sono stati\n          già scartati\n        '
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm.ie
            ? _c(
                "div",
                { staticStyle: { overflow: "auto" } },
                [
                  _c(
                    "v-list",
                    { staticClass: "pa-0", attrs: { "two-line": "" } },
                    _vm._l(_vm.id_calciatori_svincolati, function (id, index) {
                      return _c("calciatore", {
                        key: id,
                        staticClass: "svincolati-calciatore",
                        class: {
                          textScuro: _vm.textScuro,
                          bgChiaro: _vm.bgChiaro,
                          "calciatore-visually-disabled":
                            _vm.isVisuallyDisabled(id),
                        },
                        attrs: {
                          borderAsRuolo: "",
                          showQuotazione: _vm.showQuotazione,
                          showMainStatus: _vm.showMainStatus,
                          showCuori: _vm.showCuori,
                          showButtonsScartaRiabilita:
                            _vm.showButtonsScartaRiabilita,
                          disableSelection: _vm.disableSelection,
                          showStats: _vm.showStats,
                          small: _vm.smallCalciatori,
                          ruoloRight: "",
                          id: id,
                          runningNumber: index + 1,
                          selected: _vm.hasCalciatoreSelectionAction
                            ? _vm.selectCalciatore.bind(null, id)
                            : null,
                          ripple: _vm.ripple || _vm.canDirectAssign,
                          scartato: _vm.scartati_ids.indexOf(id) != -1,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c("RecycleScroller", {
                    ref: "vscroll-list",
                    staticClass: "recycle-scroller",
                    class: { "nice-scroll": !_vm.is_mobile },
                    attrs: {
                      items: _vm.id_calciatori_svincolati,
                      "item-size": _vm.calciatoreItemSize,
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var id_calciatore_svincolato = ref.item
                          var index = ref.index
                          return [
                            _c("calciatore", {
                              class: {
                                textScuro: _vm.textScuro,
                                bgChiaro: _vm.bgChiaro,
                                "calciatore-visually-disabled":
                                  _vm.isVisuallyDisabled(
                                    id_calciatore_svincolato
                                  ),
                              },
                              attrs: {
                                borderAsRuolo: "",
                                showQuotazione: _vm.showQuotazione,
                                showMainStatus: _vm.showMainStatus,
                                showCuori: _vm.showCuori,
                                showButtonsScartaRiabilita:
                                  _vm.showButtonsScartaRiabilita,
                                disableSelection: _vm.disableSelection,
                                showStats: _vm.showStats,
                                small: _vm.smallCalciatori,
                                ruoloRight: "",
                                ripple: _vm.ripple || _vm.canDirectAssign,
                                id: id_calciatore_svincolato,
                                runningNumber: index + 1,
                                selected: _vm.hasCalciatoreSelectionAction
                                  ? _vm.selectCalciatore.bind(
                                      null,
                                      id_calciatore_svincolato
                                    )
                                  : null,
                                scartato:
                                  _vm.scartati_ids.indexOf(
                                    id_calciatore_svincolato
                                  ) != -1,
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
        ]),
      ]),
      _vm._v(" "),
      _vm._t("footer", null, {
        ruoloClassic: _vm.selectedRuoloClassic,
        ruoliMantra: _vm.selectedRuoliMantra,
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "350" },
          model: {
            value: _vm.dialogInformazioni,
            callback: function ($$v) {
              _vm.dialogInformazioni = $$v
            },
            expression: "dialogInformazioni",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "navy white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("info")]
                  ),
                  _vm._v("\n        Ricorda\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismissDialogInformazioni },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "white" }, [
                _vm.ruolo_da_chiamare ==
                _vm.Constants.RUOLO_DA_CHIAMARE.QUALUNQUE
                  ? _c("div", { staticClass: "pa-4" }, [
                      _vm._v(
                        "\n          PS: Se un ruolo non dovesse essere selezionabile è perchè quel ruolo\n          è stato già completato da chi sta chiamando.\n        "
                      ),
                    ])
                  : _c("div", { staticClass: "pa-4" }, [
                      _vm._v(
                        "\n          PS: Se il ruolo non dovesse essere selezionabile è perchè quel ruolo\n          è stato già completato da chi sta chiamando.\n        "
                      ),
                    ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }